/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';

import AddressComponent from "premier-capability-policyjob-react/components/AddressComponent/AddressComponent";
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import messages from "gw-capability-quoteandbind-PremierPL-react/components/subcomponents/Information/InformationComponent.messages.js";
import metadata from './InformationComponent.metadata.json5';
import styles from '../FoodTruck/FoodTruck.module.scss';
import CoveragesPageComponent from "../../pages/Coverages/CoveragesPage";
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function InformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('InformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [actAddress, setActAddress] = useState(null)

    modelVM.isValidationReq.value = true

    if (_.isUndefined(modelVM.accountLocFie.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const initializePropertyFields = () => {
        const occFieValue = _.get(modelVM, 'occFie.value') !== undefined
            ? _.get(modelVM, 'occFie.value') : 'Commercial';

        _.set(modelVM, 'occFie.value', occFieValue);
    }

    useEffect(() => {
        initializePropertyFields()
    }, [])

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {

            modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };

    const setDefaultYear = (changedPath, value) => {
        if (changedPath === 'yeaBuiFie' && modelVM.value.yeaBuiFie.length === 4) {
            if (modelVM.value.priHeaLasUpdFie === undefined) {
                _.set(submissionVM, `${pathUpdated}.priHeaLasUpdFie`, value);
            }

            if (modelVM.value.eleYealasupdFie === undefined) {
                _.set(submissionVM, `${pathUpdated}.eleYealasupdFie`, value);
            }

            if (modelVM.value.pluYealasupdFie === undefined) {
                _.set(submissionVM, `${pathUpdated}.pluYealasupdFie`, value);
            }
        }
    }

    const setproGraFie = () => {
        if (!_.isUndefined(modelVM.value.distoFirHydFie) && !_.isUndefined(modelVM.value.distotheFirHalFie)) {
            if (modelVM.value.distoFirHydFie === 'Within150m' || modelVM.value.distoFirHydFie === 'Within300m') {
                if (modelVM.value.distotheFirHalFie === 'Within5km' || modelVM.value.distotheFirHalFie === 'Bet5kmTo8km') {
                    modelVM.value.proGraFie = 'Pro'
                } else if (modelVM.value.distotheFirHalFie === 'Over8km') {
                    modelVM.value.proGraFie = 'UnPro'
                }
            }
            
            if (modelVM.value.distoFirHydFie === 'Over300m') {
                if (modelVM.value.distotheFirHalFie === 'Within5km') {
                    modelVM.value.proGraFie = 'Pro'
                } else if (modelVM.value.distotheFirHalFie === 'Bet5kmTo8km') {
                    modelVM.value.proGraFie = 'SemPro'
                } else if (modelVM.value.distotheFirHalFie === 'Over8km') {
                    modelVM.value.proGraFie = 'UnPro'
                }
            }
        }
    }

    const handleValueChange = useCallback(
        (value, changedPath) => {
            let fullPath = `${pathUpdated}.${changedPath}`;

            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            }

            if (changedPath === 'neighbouringAcc' || changedPath === 'neighbouring') {
                fullPath = `${pathUpdated}.${changedPath}.value`;

                if (_.isUndefined(_.get(submissionVM, `${fullPath}`))) {
                    _.set(submissionVM, `${fullPath}`, []);
                }

                _.set(submissionVM, `${fullPath}`, value);
            } else {
                _.set(submissionVM, `${fullPath}`, value);
            }

            setDefaultYear(changedPath, value);

            updateWizardData(submissionVM);

            if (changedPath === 'distoFirHydFie' || changedPath === 'distotheFirHalFie') {
                setproGraFie()
            }

            updateWizardData(submissionVM);

        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);


    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        ifOthDesFie: {
            visible: !_.isUndefined(modelVM.value.conFie) && modelVM.value.conFie === 'Other'
        },
        eleSysOthPledesFie: {
            visible: !_.isUndefined(modelVM.value.eleSysFie) && modelVM.value.eleSysFie === 'Other'
        },
        ifOthExpFie: {
            visible: !_.isUndefined(modelVM.value.othFie) && modelVM.othFie.value,
        },
        priHeaIfOthPledesFie: {
            visible: !_.isUndefined(modelVM.value.priHeaFie) && modelVM.value.priHeaFie === 'Other'
        },
        NeighbouringTitle: { visible: false },
        TypesofNeighbourTitle: { visible: false },
        busFie: { visible: false },
        comFie: { visible: false },
        hosFie: { visible: false },
        indFie: { visible: false },
        offFie: { visible: false },
        resFie: { visible: false },
        othFie: { visible: false },
        occFie: { visible: false },
        yeaofRooUpdFie: { visible: false },
        UtilitiesDetailsTitle: { visible: false },
        priHeaFie: { visible: false },
        priHeaLasUpdFie: { visible: false },
        eleSysFie: { visible: false },
        eleYealasupdFie: { visible: false },
        pluYealasupdFie: { visible: false }
    };


    const deleteinformation = useCallback(
        () => {
            const infoListPath = 'lobData.eveLiaLine.coverables.locRisks.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yes,
                cancelButtonText: commonMessages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );


    const resolvers = {
        resolveCallbackMap: {
            deleteinformation,
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            AddressComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

InformationComponent.propTypes = wizardProps;
export default withRouter(InformationComponent);
